<template>
  <header class="home-header">
    <div class="logo" @click="goHome()">
      <img src="../../assets/img/logo.png" alt>
    </div>
    <span @click="goReg()">{{ $t('a1') }}</span>
    <div class="more" @click="goMenu()">
      <!-- <img src="../../assets/img/more.png" alt> -->
      <span class="icopnm">{{ $t('a2') }}</span>
    </div>
  </header>
</template>
<script>
export default {
  name: "myhead",
  data() {
    return {};
  },
  methods: {
    goMenu() {
      this.$router.push("/menu");
    },
    goReg() {
      this.$router.push("/register");
    },
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>
<style lang="less" scoped>
.home-header {
  box-sizing: border-box;
  top: 0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 44px;
  line-height: 44px;
  color: #fff;
  text-align: right;
  background: #f8f8f8;
  width: 100%;
  max-width: 650px;
  margin: 0 auto;
  left: 50%;
  transform: translateX(-50%);
  // background-color: #159F42;
  // background: linear-gradient(
  //   90deg,
  //   rgba(12, 126, 49, 1),
  //   rgba(27, 163, 71, 1)
  // );
  // background: linear-gradient(90deg, rgba(0, 45, 120, 1), rgba(0, 20, 67, 1));
  padding: 0 20px;
  z-index: 2000;
  span {
    margin-right: 40px;
    color: #333333;
    font-weight: 700;
  }

  .logo {
    width: 80px;
    height: 18px;
    position: absolute;
    left: 20px;
    top: 13px;
  }

  .more {
    position: absolute;
    width: 15px;
    height: 13px;
    top: 15px;
    right: 20px;
    .icopnm {
      position: absolute;
      font-size: 14px;
      left: -12px;
      top: -14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Myhead/myhead.vue